import { NcLoadingIndicator } from "@noted/noted-components";

function LoadingCard() {
  return (
    <section className="bg-light text-dark p-6 text-center shadow-xl not-only-of-type:rounded-sm">
      <NcLoadingIndicator />
    </section>
  );
}

export default LoadingCard;
